export default "__VITE_ASSET___KCmflzc__";